import React, { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingOverlay from 'components/LoadingOverlay';
import ClaimsProcess from 'products/nomad_insurance/components/ClaimsProcess';
import { fetchClaims } from './state';
import { Container, LeftCol, RightCol, Header } from './styled';
import ClaimRow from './components/ClaimRow';

const ClaimsDashboard = () => {
  const dispatch = useDispatch();
  const { claims, isLoading } = useSelector(
    (state) => state.nomadInsurance.profile.claims
  );
  const { contractsIncludingExpired } = useSelector(
    (state) => state.nomadInsurance.contract
  );

  const hasHadSafetyWingContract = useMemo(() => {
    return contractsIncludingExpired?.some(
      (contract) => contract.insuranceProvider === 'SAFETYWING'
    );
  }, [contractsIncludingExpired]);

  useEffect(() => {
    if (hasHadSafetyWingContract) {
      dispatch(fetchClaims());
    }
  }, [dispatch, hasHadSafetyWingContract]);

  const hasClaims = useMemo(() => claims?.length > 0, [claims]);

  const sortedClaims = useMemo(() => {
    if (!claims?.length) return [];
    return [...claims].sort((a, b) => {
      if (a.claimSubmissionStatus === 'Filing' && b.claimSubmissionStatus !== 'Filing') {
        return -1;
      }

      if (b.statusUpdates?.length && a.statusUpdates?.length) {
        return (
          new Date(b.statusUpdates[0]?.statusChangedOn) -
          new Date(a.statusUpdates[0]?.statusChangedOn)
        );
      }

      return 0;
    });
  }, [claims]);

  const header = useMemo(() => {
    if (!contractsIncludingExpired?.length)
      return 'What is the Nomad Insurance claim process like?';

    if (hasClaims) return 'Your claims';

    return 'Submit a claim';
  }, [contractsIncludingExpired, claims]);

  return (
    <Container>
      <LoadingOverlay isLoading={isLoading} variant="global" />
      <LeftCol hasClaims={hasClaims}>
        <Header>{header}</Header>
        <ClaimsProcess />
      </LeftCol>
      <RightCol hasClaims={hasClaims}>
        {sortedClaims.map((claim) => (
          <ClaimRow key={claim.id} claim={claim} />
        ))}
      </RightCol>
    </Container>
  );
};

export default ClaimsDashboard;
